import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const AggregationIcon = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M2.5 4V7.5C2.5 8.05228 2.94772 8.5 3.5 8.5H9" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M0.5 6V9.5C0.5 10.0523 0.947715 10.5 1.5 10.5H7" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <rect x="4.5" y="1.5" width="7" height="5" rx="1" className="stroke-current" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <Svg width={12} height={12} {...props}>{t0}{t1}{t2}</Svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AggregationIcon;